export const DATA = {
	questions: [
		{
			title: "Когда его долго нет, а телефон <span>выключен</span>, я...",
			answers: [
				{
					id: "А",
					text: "Ухожу на вечеринку с друзьями — пусть он тоже понервничает.",
				},
				{
					id: "Б",
					text: "Совершенно спокойна, он часто так делает.",
				},
				{
					id: "В",
					text: "Решаю подождать еще час, прежде чем звонить коллегам и родным.",
				},
			],
		},
		{
			title: "Романтичные выходные за городом прерываются приездом <span>вашей сестры</span> и… вашего <span>бывшего мужчины</span>. Что предпримете?",
			answers: [
				{
					id: "А",
					text: "Между этими двумя что-то есть. Быстро же он меня забыл! Надо рассорить парочку.",
				},
				{
					id: "Б",
					text: "Достану валерьянку — мой любимый будет расстроен.",
				},
				{
					id: "В",
					text: "Что за странная компания. Кажется, нам пора возвращаться домой.",
				},
			],
		},
		{
			title: "Мужчина признается вам <span>в любви.</span> Ваша реакция?",
			answers: [
				{
					id: "А",
					text: "Любить меня вечно не получится.",
				},
				{
					id: "Б",
					text: "Такое не произойдет. За любовь здесь отвечаю я.",
				},
				{
					id: "В",
					text: "Признаюсь в ответ — всегда так делаю, если люблю.",
				},
			],
		},
		{
			title: "Мужчина нашел вашу <span>переписку</span> <span>с другим.</span> Что за этим последует?",
			answers: [
				{
					id: "А",
					text: "Пожму плечами: он не уделял мне должного внимания и теперь пожинает плоды своего безразличия.",
				},
				{
					id: "Б",
					text: "Теперь буду знать, что и самую невинную переписку нужно сразу удалять.",
				},
				{
					id: "В",
					text: "Дорогой, нам давно пора поговорить.",
				},
			],
		},
		{
			title: "Вы чувствуете, что <span>между вашей</span> парой и <span>семейной</span> <span>парой</span> ваших друзей растут недоговоренности. Что происходит?",
			answers: [
				{
					id: "А",
					text: "М-м-м, любовный многоугольник! Это интересно.",
				},
				{
					id: "Б",
					text: "Кажется, муж положил глаз на жену друга. Вряд ли отношения получат развитие, но мне неприятно.",
				},
				{
					id: "В",
					text: "Мы слишком разные, нужно дистанцироваться.",
				},
			],
		},
		{
			title: "Ваш любимый <span>солгал</span>: заявил, что уезжает в командировку, а сам взял отпуск и уехал в неизвестном направлении. Как разрешить ситуацию?",
			answers: [
				{
					id: "А",
					text: "Что-то у меня давление скакнуло. И голова кружится…",
				},
				{
					id: "Б",
					text: "Все бесполезно. Он опять скажет, что я начиталась романов и выдумала какую-то чушь.",
				},
				{
					id: "В",
					text: "Тоже на время уеду. Надо успокоиться и разобраться в себе.",
				},
			],
		},
		{
			title: "Стоит вам задержаться на работе — и дома <span>неизбежен скандал</span>. Как вы к этому относитесь?",
			answers: [
				{
					id: "А",
					text: "Хорошая встряска для обоих. Потом мы страстно «миримся».",
				},
				{
					id: "Б",
					text: "Поговорю с руководством. Пусть завершают проект без меня.",
				},
				{
					id: "В",
					text: "Предложу ему тоже взять подработку. Ипотека сама себя не закроет!",
				},
			],
		},
	],
	results: [
		{
			id: "А",
			title: "Опытный кукловод",
			info: "Умело расставляя сети и упиваясь властью серого кардинала, вы обрекаете себя на эмоциональный эскапизм и одиночество, даже если близкий человек всегда рядом. Люди годами живут в паутине лжи и полуправды, разрушая собственное эго и превращая эмоциональную связь в текущий по венам яд. Пора разобраться, для чего вам понадобился столь сомнительный сценарий жизни.",
			description:
				"Манипулятивные игры со множеством участников совершенны в своей сложности. Более того, они интригуют. В пылу страстей игроки ставят всё на красное. Выиграют или проиграют? Узнайте в кинотеатре за просмотром фильма «Соври мне правду».",
			quote: "Сюжетов о любви и сексе существует бесчисленное множество, но «Соври мне правду» — это такой непредсказуемый психологический аттракцион, от которого порой захватывает дух.",
			author: "Павел Прилучный",
		},
		{
			id: "Б",
			title: "Жертва манипулятора",
			info: "В какой-то момент поддавшись манипуляциям, как бы ни сложилась история этих отношений в дальнейшем, вы останетесь в проигрыше. Попытка выстроить личные границы не обязательно приведет к успеху, но предпринять ее нужно обязательно. Возьмите лист бумаги и выпишите все за и против этих отношений. Вероятно, здесь уже не за что держаться.",
			description:
				"Любовная идиллия может разрушиться молниеносно. Как далеко человек способен зайти в жестокой психологической игре? Уже очень скоро мы узнаем ответ в новом фильме «Соври мне правду», получившем признание критиков и жюри международных кинофестивалей.",
			quote: "Для меня это был первый опыт съемок постельных сцен, настолько откровенных и чувственных.",
			author: "Дарья Мельникова",
		},
		{
			id: "В",
			title: "Гениальный аналитик",
			info: "Благодаря болезненному опыту или природной рассудочности вы точно знаете, как оградить себя от манипуляций. Вопрос в другом: насколько вы честны с собой? Четкие представления о том, как строятся здоровые отношения, не мешают темной натуре внутри вас время от времени прорываться сквозь тонкий налет цивилизованности.",
			description:
				"Игры манипуляторов неминуемо приводят к драме. Кто станет жертвой на этот раз? Не пропустите эротический триллер «Соври мне правду», раскрывающий саму суть психологии манипулятора.",
			quote: "Мое внимание захватили, не побоюсь этого слова, головокружительные отношения двух главных героев. Что с вами происходит, ребята? – задался вопросом я.",
			author: "Евгений Романцов",
		},
	],
};



// WEBPACK FOOTER //
// ./app/scripts/data.js